export enum RoleEnum {
  Landowner = 'Landowner',
  Admin = 'Admin',
  SuperAdmin = 'SuperAdmin',
  ReadAdmin = 'ReadAdmin',
  FinanceAdmin = 'FinanceAdmin',
  None = 'No Role',
}
